import styled from 'styled-components'

import { helpers } from 'styles'

type Props = {
	$isSelected: boolean
}

export const CardIcon = styled.span<Props>`
	align-items: center;
	background-color: ${({ $isSelected }) => ($isSelected ? '#eaefcb' : '#dde0d7')};
	border-radius: 50%;
	display: flex;
	height: 46px;
	justify-content: center;
	width: 46px;

	color: ${helpers.color.pageHeader};
`
